import React, { memo, useMemo } from "react";
import { Stack, Icon, Tooltip, IconButton } from "investira.react.components";
import { BulkContextActions, DataTable } from "../../components/organisms";
import { useRecursoGarantidorContext } from "../../contexts/RecursoGarantidorContext";
import { validators, formats, dates } from "investira.sdk";

const RecursoGarantidorDataGrid = memo(() => {
  const { state, actions } = useRecursoGarantidorContext();

  const columns = useMemo(
    () => [
      {
        accessorKey: "data",
        header: "Data",
        enableColumnActions: false,
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
      {
        accessorKey: "pl",
        header: "Patrimônio Líquido (R$)",
        enableColumnActions: false,
        enableSorting: false,

        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatNumber(cell.getValue(), 2, true);
        },
      },
      {
        accessorKey: "emprestimo",
        header: "Empréstimo (R$)",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatNumber(cell.getValue(), 2, true);
        },
      },
      {
        accessorKey: "imovel",
        header: "Imóvel (R$)",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatNumber(cell.getValue(), 2, true);
        },
      },
      {
        accessorKey: "caixa",
        header: "Caixa (R$)",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatNumber(cell.getValue(), 2, true);
        },
      },
      {
        accessorKey: "provisoes",
        header: "Provisões (R$)",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatNumber(cell.getValue(), 2, true);
        },
      },
    ],
    []
  );

  const xProps = {
    columns,
    data: state.recursos,
    readData: actions.readCarteiras,
    isLoading: state.isLoading,
    manualPagination: true,
    getRowId: (row) => {
      return row.data;
    },
    state: {
      isLoading: state.isLoading,
      pagination: state.pagination,
      showProgressBars: state.isRefetching,
      rowSelection: state.rowSelection,
    },
    initialState: {
      density: "comfortable",
    },
    enableRowSelection: true,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "",
      },
    },
    rowCount: state.rowCount,
    onPaginationChange: actions.handlePaginationChanged,
    onRowSelectionChange: actions.handleRowSelectionChanged,
    renderTopToolbarCustomActions: ({ table }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            actions.handleBulkDelete(selectedRows);
          }}
          disabled={
            state.isLoading || state.showProgressBars || !isSomeRowSelected
          }
        />
      );
    },
    renderRowActions: ({ row }) => {
      const { carteira_id, favorito } = row.original;
      return (
        <Stack direction="row" spacing={2}>
          <Tooltip title="Editar">
            <IconButton
              color="primary"
              onClick={() => {
                actions.handleDialogChanged("edit");
                actions.handleRecursoSelectedChanged(row.original);
              }}
            >
              <Icon iconName="edit" size={21} />
            </IconButton>
          </Tooltip>
        </Stack>
      );
    },
  };

  return <DataTable {...xProps} />;
});

export default RecursoGarantidorDataGrid;
